<template>
	<ul class="timeline" :class="{ packed: isPacked }">
		<slot></slot>
		<li id="showmore" class="showmore clickable" @click="showmore" v-if="isPacked">查看更多</li>
	</ul>
</template>
<script>
export default {
  name: "timeline",
  props: {
    isPacked: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    showmore() {
      var l = document.querySelectorAll(".hidden");
      for (let i = 0; i < l.length; i++) {
        l[i].className = "line-item on ";
	  }
	 document.getElementById("showmore").style.display="none";  
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/timeline/timeline.vue